var legend = document.querySelector('.color__select');

document.querySelectorAll('.color-swatches').forEach(item => {
    item.addEventListener('click', event => {
      //console.log("clicked!")
      //console.log(item.className)

      var classArray = item.className.split(" ");

      legend.innerHTML = 'Color | <b>' + classArray[1] + '</b>';
    })
  })